import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ResourceCell from './ResourceCell';

const ResourceList = props => {
  const renderSlot = (value, idx) => {
    if (idx !== 0) return null;
    return <span className={cn('rbc-label')}>{value}</span>;
  };

  return (
    <div id="resourceList">
      <div className="rbc-time-gutter rbc-time-column">
        {props.employees.map((employee, idx) => {
          return (
            <ResourceCell
              key={idx}
              employee={employee}
              renderSlot={renderSlot}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ResourceList;
